"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const toast_styles_1 = require("@/components/overlay/toast/toast.styles");
const portal_controller_1 = require("@/controllers/portal-controller");
const schedule_controller_1 = require("@/controllers/schedule-controller");
const open_state_1 = require("@/utils/open-state");
// 스스로 닫히기까지의 표시 시간(ms). transient 동작은 내부 책임이라 prop으로 노출하지 않는다.
const DURATION = 3000;
/**
 * 화면 하단 중앙에 잠깐 떠올랐다 스스로 사라지는 transient non-modal 레이어.
 * mm-sheet처럼 열림 상태(open/close)를 스스로 소유하고 portal 컨테이너로 옮겨지되, backdrop·스크롤 잠금 없이
 * 배경 상호작용을 막지 않고, 표시 시간이 지나면 스스로 닫힙니다.
 * 포인터가 올라와 있거나 포커스가 들어와 있는 동안은 읽거나 조작 중이므로 시간을 멈추고, 벗어나면 처음부터 다시 잽니다.
 * portal로 옮기는 이유: 조상의 쌓임 맥락에 갇히지 않고, 모달이 열려 본문이 inert가 된 동안에도 알림이 읽히게 한다.
 */
let Toast = class Toast extends (0, open_state_1.withOpenState)(lit_1.LitElement) {
    constructor() {
        super();
        this.hideTimer = new schedule_controller_1.ScheduleController(this, () => this.close(), { delay: DURATION });
        this.engagedBy = new Set();
        this.portal = new portal_controller_1.PortalController(this);
        this.handleHostEnter = (event) => {
            this.engagedBy.add(event.type === 'mouseenter' ? 'hover' : 'focus');
            this.hideTimer.cancel();
        };
        // 포인터와 포커스 중 하나라도 남아 있으면 계속 멈춰 둔다.
        this.handleHostLeave = (event) => {
            this.engagedBy.delete(event.type === 'mouseleave' ? 'hover' : 'focus');
            if (!this.open)
                return;
            this.restartTimer();
        };
        // 리스너 대상이 host 자신이라 연결이 바뀌어도 유지되므로 생성자에서 한 번만 등록한다.
        this.addEventListener('mouseenter', this.handleHostEnter);
        this.addEventListener('focusin', this.handleHostEnter);
        this.addEventListener('mouseleave', this.handleHostLeave);
        this.addEventListener('focusout', this.handleHostLeave);
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'status');
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
    show() {
        super.show();
        this.restartTimer();
    }
    close() {
        this.hideTimer.cancel();
        this.engagedBy.clear();
        super.close();
    }
    // 열려 있을 때 다시 열면 남은 시간을 초기화한다. 읽거나 조작 중이면 시간을 재지 않는다.
    restartTimer() {
        if (this.engagedBy.size > 0) {
            this.hideTimer.cancel();
            return;
        }
        this.hideTimer.request();
    }
};
Toast.styles = toast_styles_1.toastStyles;
Toast = __decorate([
    (0, decorators_js_1.customElement)('mm-toast')
], Toast);
exports.Toast = Toast;
//# sourceMappingURL=data:application/json;base64,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